// extracted by mini-css-extract-plugin
module.exports = {"column":"_1u_zq8cBAzoLBVPUFJOT","droppable":"_2jwnEgfYmYnOtqXeS-Q-","-drag-over":"_1rKzA-jCw9o-C5F7a3Nx","header":"_2q9XdwsACzFqqAoW_WwX"};